"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuitarLookupServiceImpl = void 0;
const chord_lookup_1 = require("../chord-lookup");
/**
 * Used to look up note names on a guitar fret and get finger positions for chords
 */
class GuitarLookupServiceImpl {
    /**
     * @param chordPositionsMap Map of chord positions by chord name and quality
     * @param openNotes Notes that the strings are tuned to (from top to bottom, high to low)
     */
    constructor(chordPositionsMap, openNotes) {
        this.chordPositionsMap = chordPositionsMap;
        this.openNotes = openNotes;
    }
    getNote(str, fret) {
        return this.openNotes[str].transpose(fret);
    }
    getNotes(tab) {
        // The string in getNote is in reverse order from tab order
        const notes = tab.slice().reverse().map((fret, i) => fret >= 0 ? this.getNote(i, fret) : undefined);
        // Put back in tab order
        return notes.reverse();
    }
    getChordTabs(name, quality) {
        if (quality === "M")
            quality = "";
        return this.chordPositionsMap[name + quality];
    }
    getChordTab(name, quality, variation) {
        //console.log("guitar chord: " + name + quality + variation);
        const chords = this.chordPositionsMap[name + ((quality === "M") ? "" : quality)];
        return (chords && chords[variation] ? chords[variation].slice() : undefined);
    }
    getChordVariationCount(name, quality) {
        const tabs = this.getChordTabs(name, quality);
        return tabs ? tabs.length : 0;
    }
    getChordFromTab(tab) {
        let notes = this.getNotes(tab);
        // Remove undefined and duplicates
        notes = notes.filter((n, i) => n && notes.findIndex(n1 => n1 === null || n1 === void 0 ? void 0 : n1.isSameAs(n)) === i);
        return (0, chord_lookup_1.getChordFromNotes)(...notes);
    }
}
exports.GuitarLookupServiceImpl = GuitarLookupServiceImpl;
//# sourceMappingURL=guitar-lookup-service.js.map